import { api } from './client';
import { Site, NewSite, UpdateSite, SitesResponse } from '@/types/site';
import { PaginationParams } from '@/types/api';

export const sitesApi = {
  // Get paginated sites list
  getSites: async (pagination: PaginationParams): Promise<SitesResponse> => {
    const params = new URLSearchParams({
      page: pagination.page.toString(),
      size: pagination.size.toString(),
    });

    if (pagination.orderBy) {
      params.append('orderBy', pagination.orderBy);
    }

    return api.get<SitesResponse>(`/sites?${params.toString()}`);
  },

  // Get single site by ID
  getSiteById: async (siteId: string): Promise<Site> => {
    return api.get<Site>(`/sites/${siteId}`);
  },

  // Create new site
  createSite: async (siteData: NewSite): Promise<Site> => {
    return api.post<Site>('/sites/new', siteData);
  },

  // Update existing site
  updateSite: async (siteData: UpdateSite): Promise<Site> => {
    return api.put<Site>('/sites/update', siteData);
  },

  // Delete site
  deleteSite: async (siteId: string): Promise<void> => {
    return api.delete(`/sites/${siteId}`);
  },

  // Search sites with filters
  searchSites: async (
    pagination: PaginationParams,
    filters: Record<string, string>
  ): Promise<SitesResponse> => {
    const params = new URLSearchParams({
      page: pagination.page.toString(),
      size: pagination.size.toString(),
    });

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    return api.get<SitesResponse>(`/sites/search?${params.toString()}`);
  },
};
